module.exports = __webpack_public_path__ + "static/media/csv.e83ec20c.svg";